
/* TAMAKI TEA - B2B card variant selector */

(function () {
  function getCard(element) {
    return element.closest('[data-tamaki-card-order]');
  }

  document.addEventListener('click', function (event) {
    const format = event.target.closest('.tamaki-card-order__format');

    if (format) {
      const card = getCard(format);
      if (!card || format.disabled) return;

      const buttons = card.querySelectorAll('.tamaki-card-order__format');

      buttons.forEach(function (button) {
        const selected = button === format;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      card.querySelector('[data-selected-variant]').value =
        format.dataset.variantId;

      card.querySelector('[data-card-price]').textContent =
        format.dataset.price;

      const quantity = card.querySelector('[data-qty-input]');
      const min = Number(format.dataset.min) || 1;
      const step = Number(format.dataset.step) || 1;

      quantity.min = min;
      quantity.step = step;
      quantity.value = min;

      if (format.dataset.max) {
        quantity.max = format.dataset.max;
      } else {
        quantity.removeAttribute('max');
      }

      const addButton = card.querySelector('[data-card-add]');
      const available = format.dataset.available === 'true';

      addButton.disabled = !available;
      addButton.textContent = available ? 'Ajouter au panier' : 'Épuisé';

      return;
    }

    const minus = event.target.closest('[data-qty-minus]');
    const plus = event.target.closest('[data-qty-plus]');

    if (!minus && !plus) return;

    const card = getCard(minus || plus);
    if (!card) return;

    const input = card.querySelector('[data-qty-input]');

    const min = Number(input.min) || 1;
    const step = Number(input.step) || 1;
    const max = input.max ? Number(input.max) : Infinity;

    let current = Number(input.value) || min;

    if (minus) {
      current = Math.max(min, current - step);
    } else {
      current = Math.min(max, current + step);
    }

    input.value = current;
  });

  
  // Add B2B products without leaving the page
  document.addEventListener('submit', async function (event) {
    const form = event.target;

    if (!form.matches('.tamaki-card-order__form')) return;

    const drawer = document.querySelector('cart-drawer');

    // Keep normal form submission if the drawer is unavailable
    if (!drawer || typeof drawer.renderContents !== 'function') return;

    event.preventDefault();

    const button = form.querySelector('[data-card-add]');
    if (button.disabled) return;

    button.disabled = true;
    button.textContent = 'Ajout en cours...';

    try {
      const formData = new FormData(form);

      formData.append('sections', 'cart-drawer,cart-icon-bubble');
      formData.append('sections_url', window.location.pathname);

      const response = await fetch(form.action + '.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        },
        body: formData
      });

      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'Erreur');
      }

      if (!result.sections || !result.sections['cart-drawer']) {
        throw new Error('Impossible de mettre à jour le panier.');
      }

      if (typeof drawer.setActiveElement === 'function') {
        drawer.setActiveElement(button);
      }


drawer.renderContents(result);

// Reset the empty-cart state after adding a product
drawer.classList.remove('is-empty');
drawer.querySelector('cart-drawer-items')?.classList.remove('is-empty');

button.textContent = 'Ajouter au panier';


    } catch (error) {
      console.error('TAMAKI cart error:', error);
      alert(error.message || "Impossible d'ajouter le produit au panier.");
      button.textContent = 'Ajouter au panier';
    } finally {
      button.disabled = false;
    }
  });

})();
